var _      = require('lodash');
var moment = require('moment');


function getNextOpenHouse(listing) {
    var openHouses = typeof listing.open_houses === 'string' ? [listing.open_houses] : listing.open_houses || [];
    openHouses = openHouses
    .map(function (openHouse) {
        if(!openHouse) openHouse = '0000-00-00';
        return openHouse;
    })
    .filter(function (openHouse) {
        return moment(openHouse).isAfter(moment().format('YYYY-MM-DD'));
    })
    .sort();

    return openHouses[0];
}

function orderByOpenHouse(listings, order) {
    order = order || 'asc';
    listings = listings.map(function (listing) {
        listing.next_open_house = getNextOpenHouse(listing);
        return listing;
    });
    listings = _.orderBy(listings, ['next_open_house', 'match_score', 'address'], [order, 'desc', 'asc']);
    listings = listings.map(function (listing) {
        delete listing.next_open_house;
        return listing;
    });

    return listings;
}

function orderListingsBy(listings, orderBy) {
    orderBy = orderBy || 'match_score:desc';
    var orderBySplit = orderBy.split(':');
    var prop = orderBySplit[0];
    var order = orderBySplit[1] || 'asc';

    if(prop === 'match_score') {
        return _.orderBy(listings, [prop, 'listing_date', 'address'], [order, 'desc', 'asc']);
    } else if(prop === 'open_house') {
        return orderByOpenHouse(listings, order);
    } else {
        return _.orderBy(listings, [prop, 'match_score', 'address'], [order, 'desc', 'asc']);
    }
}


module.exports = orderListingsBy;
